"use strict";

var Partnering = function () {

  var handlePDF = function () {
    $('.page-connect-meet').on('click', '.btn-pdf', function (e) {
      e.stopPropagation();
      var $this = $(this);
      var url = $this.data("url");
      var upaction = $this.data("upaction");
      var action = $this.data("action");
      var id = $this.data("id");

      url ="/"+url+"?upaction="+upaction+"&action="+action+"&id="+id;
      window.open(url, '_blank');
    });

    $('.page-connect-meet').on('click', '.btn-entity-pdf', function (e) {
      e.stopPropagation();
      var $this = $(this);
      var url = $this.data("url");
      var upaction = $this.data("upaction");
      var action = $this.data("action");
      var recipient_entity = $this.data("recipient_entity");
      var uid = $this.data("uid");
      var entity = $this.data("entity");
      var now = $this.data("now");

      url ="/"+url+"?upaction="+upaction+"&action="+action+"&recipient_entity="+recipient_entity+(uid ? "&uid="+uid : '')+(entity ? "&entity="+entity : '')+(now ? "&now="+now : '');
      window.open(url, '_blank');
    });

  };

  var handleBack = function () {
    $('.btn-back').click(function(){
      parent.history.back();
      return false;
    });
  };

  var handleCloseWindow = function () {
    $('.btn-close-window').on('click', function(e) {
      e.stopPropagation();
      window.close();
    });
  };

  var handleReloadWindow = function () {
    $('.btn-reload-window').on('click', function(e) {
      e.stopPropagation();
      location.reload();
    });
  };

  var handleSubmitForm = function () {
    $('.btn-submit').on('click', function(e) {
      e.stopPropagation();
      $('.btn-submit').prop('disabled', true);
      $('#form_submit').submit();
    });
  };

  var handleSubmitFormSaveMail = function () {
    $('.btn-save-mail').on('click', function(e) {
      e.stopPropagation();
      $('#save_close_new_edit').val(4);
      $('.btn-save-mail').hide();
      $('.btn-save-new').hide();
      $('.btn-save-edit').hide();
      $('.btn-save-close').hide();
      $('.btn-save-dropdown').hide();
      $('.btn-delete-close').hide();
      $('#form_submit').submit();
    });
  };

  var handleSubmitFormSaveClose = function () {
    $('.btn-save-close').on('click', function(e) {
      e.stopPropagation();
      $('#save_close_new_edit').val(0);
      $('.btn-save-mail').hide();
      $('.btn-save-new').hide();
      $('.btn-save-edit').hide();
      $('.btn-save-close').hide();
      $('.btn-save-dropdown').hide();
      $('.btn-delete-close').hide();
      $('#form_submit').submit();
    });
  };

  var handleSubmitFormSaveEdit = function () {
    $('.btn-save-edit').on('click', function(e) {
      e.stopPropagation();
      $('#save_close_new_edit').val(1);
      $('.btn-save-mail').hide();
      $('.btn-save-new').hide();
      $('.btn-save-edit').hide();
      $('.btn-save-close').hide();
      $('.btn-save-dropdown').hide();
      $('.btn-delete-close').hide();
      $('#form_submit').submit();
    });
  };

  var handleSubmitFormSaveNew = function () {
    $('.btn-save-new').on('click', function(e) {
      e.stopPropagation();
      $('#save_close_new_edit').val(2);
      $('.btn-save-mail').hide();
      $('.btn-save-new').hide();
      $('.btn-save-edit').hide();
      $('.btn-save-close').hide();
      $('.btn-save-dropdown').hide();
      $('.btn-delete-close').hide();
      $('#form_submit').submit();
    });
  };

  var handleSubmitFormDeleteClose = function () {
    $('.btn-delete-close').on('click', function(e) {
      e.stopPropagation();
      var $this = $(this);
      var cancel = $this.data("cancel");
      var action = $('#form_submit').attr('action');

      Swal.fire({
        title: '',
        html: cancel,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: Drupal.t('Yes'),
        cancelButtonText: Drupal.t('No'),
        width: 600,
        heightAuto: false,
        padding: '2.5rem',
        customClass: {
          confirmButton: 'btn btn-success rounded-md shadow-xs px-4 py-2 mr-2',
          cancelButton: 'btn btn-danger rounded-md shadow-xs px-4 py-2 mr-2'
        },
        buttonsStyling: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          if (result) {
            $('.btn-save-mail').hide();
            $('.btn-save-new').hide();
            $('.btn-save-edit').hide();
            $('.btn-save-close').hide();
            $('.btn-save-dropdown').hide();
            $('.btn-delete-close').hide();
            $('#form_submit').attr('action', action + '/delete');
            $('#form_submit').submit();
          }
        }
      });
    });
  };

  return {
    //main function to initiate the function
    init: function() {
      handlePDF();
      handleBack();
      handleCloseWindow();
      handleReloadWindow();
      handleSubmitForm();
      handleSubmitFormSaveClose();
      handleSubmitFormSaveMail();
      handleSubmitFormSaveEdit();
      handleSubmitFormSaveNew();
      handleSubmitFormDeleteClose();
    }
  };

}();

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Partnering;
}

jQuery(document).ready(function() {
  Partnering.init();
});